import { useSyncExternalStore } from "react";

/**
 * Werkzeugkasten offen? Geöffnete Auftrags-/Artikelansichten (Dialoge) geben dann Fokus und Klicks frei, damit man
 * daneben simulieren kann, ohne die Ansicht zu schließen.
 */
let open = (() => {
  try {
    return sessionStorage.getItem("lc-devtools") === "1";
  } catch {
    return false;
  }
})();
const subs = new Set<() => void>();

export const devtoolsState = {
  get: () => open,
  set(v: boolean) {
    open = v;
    try {
      sessionStorage.setItem("lc-devtools", v ? "1" : "0");
    } catch {
      /* egal */
    }
    subs.forEach((f) => f());
  },
  subscribe(f: () => void) {
    subs.add(f);
    return () => void subs.delete(f);
  },
};

export const useDevtoolsOpen = () => useSyncExternalStore(devtoolsState.subscribe, devtoolsState.get);

/** in Dialogen: Klick/Fokus im Werkzeugkasten schließt die Ansicht nicht */
export const keepOpenForDevtools = (e: { target: EventTarget | null; preventDefault: () => void }) => {
  if ((e.target as Element | null)?.closest?.("[data-devtools]")) e.preventDefault();
};
